import {
    DateTimeCurrentFactory,
    DateTimeFactory,
    DateTimeTimerEntityFactory,
    DateTimeTimerFactory
} from 'md-library-test-first-version';

export const Providers = [
    DateTimeCurrentFactory,
    DateTimeFactory,
    DateTimeTimerFactory,
    DateTimeTimerEntityFactory
];
